export default __webpack_public_path__ + "static/media/18.917ebb97.png";